export default __webpack_public_path__ + "static/media/paper_type_1.efcec10f.png";